export default "__VITE_ASSET__CDUmIRmC__"